import { defineComponent, ref, useTemplateRef, onMounted, watch, createElementBlock, openBlock, createElementVNode, normalizeStyle, renderSlot } from "vue";
import JsBarcode from "./index111.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BarcodeRender",
  props: {
    value: {},
    format: {},
    width: {},
    height: {},
    displayValue: { type: [String, Boolean], default: true },
    text: {},
    fontOptions: {},
    font: {},
    textAlign: {},
    textPosition: {},
    textMargin: {},
    fontSize: {},
    background: {},
    lineColor: {},
    margin: {},
    marginTop: {},
    marginBottom: {},
    marginLeft: {},
    marginRight: {},
    flat: { type: Boolean },
    ean128: { type: [String, Boolean] }
  },
  setup(__props) {
    const renderBarcode = JsBarcode;
    const props = __props;
    const valid = ref(true);
    const barcodeEl = useTemplateRef("barcodeEl");
    function render() {
      if (!barcodeEl.value) return;
      const settings = {
        format: props.format,
        width: props.width,
        height: props.height,
        displayValue: props.displayValue,
        text: props.text,
        fontOptions: props.fontOptions,
        font: props.font,
        textAlign: props.textAlign,
        textPosition: props.textPosition,
        textMargin: props.textMargin,
        fontSize: props.fontSize,
        background: props.background,
        lineColor: props.lineColor,
        margin: props.margin,
        marginTop: props.marginTop,
        marginBottom: props.marginBottom,
        marginLeft: props.marginLeft,
        marginRight: props.marginRight,
        flat: props.flat,
        ean128: props.ean128,
        valid: (isValid) => {
          valid.value = isValid;
        }
      };
      Object.keys(settings).forEach((key) => {
        if (settings[key] === void 0) delete settings[key];
      });
      renderBarcode(barcodeEl.value, String(props.value), settings);
    }
    onMounted(render);
    watch(props, render, { deep: true });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [
        (openBlock(), createElementBlock("svg", {
          ref_key: "barcodeEl",
          ref: barcodeEl,
          class: "vue-barcode-element",
          style: normalizeStyle({ display: valid.value ? void 0 : "none" })
        }, null, 4)),
        createElementVNode("div", {
          style: normalizeStyle({ display: valid.value ? "none" : void 0 })
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 4)
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=index33.js.map
